export default __webpack_public_path__ + "static/media/blue hat.bd663132.svg";